// extracted by mini-css-extract-plugin
export default {"content":"PrivacyPolicy_content__GzNYE"};